import tw from 'tailwind-styled-components';

// Carousel Skeleton Loading Component
export const CarouselLoading = () => (
  <Container>
    <div className="w-full h-full bg-gray-200"></div>
  </Container>
);

// Styled Components
const Container = tw.div`
  w-full mx-auto animate-pulse
  max-h-[480px]
  aspect-video md:aspect-[16/7]
`;
